import { createReducer, on } from '@ngrx/store';
import { userActionTypes } from './user.actions';
import { User } from '../models/user.model';

export interface UserState {
  isFetching: boolean;
  users: {
    count: number;
    data: User[];
  };
}

export const initialState: UserState = {
  isFetching: false,
  users: {
    count: 0,
    data: [],
  },
};

export const userReducer = createReducer(
  initialState,
  on(userActionTypes.fetchUsersRequest, (state) => {
    return {
      ...state,
      isFetching: true,
    };
  }),
  on(userActionTypes.fetchUsersSuccess, (state, action) => {
    return {
      ...state,
      isFetching: false,
      users: action.users,
    };
  }),
  on(userActionTypes.fetchUsersFailure, (state) => {
    return {
      ...state,
      isFetching: false,
    };
  }),
  on(userActionTypes.createUsersRequest, (state) => {
    return {
      ...state,
      isFetching: true,
    };
  }),
  on(userActionTypes.createUsersSuccess, (state, action) => {
    return {
      ...state,
      isFetching: false,
      users: {
        count: state.users.count,
        data: [...state.users.data, action.user],
      },
    };
  }),
  on(userActionTypes.createUsersFailure, (state) => {
    return {
      ...state,
      isFetching: false,
    };
  }),
  on(userActionTypes.deleteUsersRequest, (state) => {
    return {
      ...state,
      isFetching: true,
    };
  }),
  on(userActionTypes.deleteUsersSuccess, (state, action) => {
    return {
      ...state,
      isFetching: false,
      users: {
        count: state.users.count,
        data: state.users.data.filter(u => !action.ids.includes(u.id))
      },
    };
  }),
  on(userActionTypes.deleteUsersFailure, (state) => {
    return {
      ...state,
      isFetching: false,
    };
  })
);
